import styles from "../../styles.module.scss"

export const AccountModalFooter = ({
  isPending,
  onCancel,
  onSave,
  isSaveDisabled,
  isCancelDisabled = false,
  saveButtonLabel = "Save changes",
}: {
  isPending: boolean
  onCancel: () => void
  onSave: () => void
  isSaveDisabled: boolean
  isCancelDisabled?: boolean
  saveButtonLabel?: string
}) => {
  return (
    <div className={styles.accountModalFooter}>
      <button
        className={styles.cancelButton}
        onClick={onCancel}
        disabled={isCancelDisabled || isPending}
      >
        Cancel
      </button>
      <button className={styles.saveButton} disabled={isSaveDisabled || isPending} onClick={onSave}>
        {isPending ? "Saving..." : saveButtonLabel}
      </button>
    </div>
  )
}
